
export class Poker2Constants {
    // CLASSPATH
    public static VO_CLASSPATH: string = "com.goodgamestudios.poker2.gamevo";
    public static OBJECT_CLASSPATH: string = "com.goodgamestudios.poker2.world.objects.";

    // INTERFACE
    public static BUDDY_PANEL_HEIGHT: number = 158;

    // FORCED EMBEDDING
    /*
    private static FORCE_EMBED_LANGUAGE_CLASSES: any[] = [
        Library.PokerInterface.language_de,
        Library.PokerInterface.language_pl,
        Library.PokerInterface.language_en,
        Library.PokerInterface.language_zh_CN,
        Library.PokerInterface.language_ja,
        Library.PokerInterface.language_cs,
        Library.PokerInterface.language_da,
        Library.PokerInterface.language_fi,
        Library.PokerInterface.language_hu,
        Library.PokerInterface.language_it,
        Library.PokerInterface.language_no,
        Library.PokerInterface.language_sv,
        Library.PokerInterface.language_ko,
        Library.PokerInterface.language_es,
        Library.PokerInterface.language_fr,
        Library.PokerInterface.language_nl,
        Library.PokerInterface.language_pt,
        Library.PokerInterface.language_ru,
        Library.PokerInterface.language_tr,
        Library.PokerInterface.language_zh_TW
    ];
    */

    public static ALLOW_AVATAR_ITEM_IDS: any[] = [10000, 10001, 10002, 10003, 10004, 10005, 10006, 10007, 10008, 10009, 11000, 11001, 11002, 11003, 12000, 12001,
        12002, 12003, 13000, 13001, 13002, 13003, 14000, 14001, 14002, 14003, 16000, 16040, 16061, 16081, 18000, 18020,
        19000, 19001, 19002, 19003,
        10010, 10011, 10012, 10013, 10014, 10015, 10016, 10017, 10018, 10019, 11030, 11031, 11032, 11033, 12020,
        12021, 12022, 12023, 13020, 13021, 13022, 13023, 14020, 14021, 14022, 14023, 16103, 16104, 16133, 16153,
        18040, 18060, 18081, 19020, 19021, 19022, 19023, 20000, 20001, 20002, 20003];
    public static AVATAR_MERGE_CATEGORY: any[] = ["tshirts", "poloshirts", "shirt", "pullover"];

    public static SEAT_COLOR: any[] = ["0xBE0000", "0x00BE00", "0x0000BE", "0xBEBE00", "0x00BEBE", "0xBE00BE", "0x8A8A8A", "0xBE5F00", "0x5500BE"];

    public static LOGGEDIN_MESSAGE_TIME_INTERVAL: number = 60000;
    public static POPUP_TIME_INTERVAL: number = 300000; // 5min

    public static MAXGIFTS: number = 99;
    public static NEW_SHOPITEM_LEFTTIME: number;	// zwei wochen

    public static EVENT_HALLOWEEN: string = "2";
    public static EVENT_CHRISTMAS: string = "3";

    public static WODID_CASH: number = 1901;
    public static WODID_GOLD: number = 1902;
    public static WODID_XP: number = 1905;

    public static SECONDFRAME_STATE_SOCIALLOGIN: string = "socialLogin";
    public static SECONDFRAME_STATE_SOCIALLOGIN_TUTORIAL: string = "loginTutorial";
    public static SECONDFRAME_STATE_STDLOGIN: string = "standardLogin";
    public static SECONDFRAME_STATE_NEWAVATAR_LOGIN: string = "newAvatar";

    public static ERROR_CONNECTION_FAILD: string = "connectionFaild";
    public static ERROR_CONNECTION_LOST: string = "connectionLost";

    public static GENDER_GIRL: string = "female";
    public static GENDER_BOY: string = "male";

    // ------ GROUP CONSTANTS
    public static GROUP_AVATAR: string = "Avatar";
    public static ITEM_CATEGORY_SCREEN: string = "screens";
    public static ITEM_CATEGORY_COSTUME: string = "costume";
    public static ITEM_CATEGORIES_MINIMALCLOTH: any[] = ["skin", "hair", "eyes", "nose", "mouth", "backgrounds"];
    public static ITEM_CATEGORY_BOTTOMUNDERWEAR: string = "underwearBottom";
    public static ITEM_CATEGORIES_BOTTOMUNDERWEAR: any[] = ["legs", "costume"];
    public static ITEM_CATEGORY_TOPUNDERWEAR: string = "underwearTop";
    public static ITEM_CATEGORIES_TOPUNDERWEAR: any[] = ["tshirts", "poloshirts", "shirt", "pullover", "suit", "jacket", "costume"];

    // GIFT CATEGORY
    public static GIFTCATEGORY_DRINK: string = "drinks";
    public static GIFTCATEGORY_FOOD: string = "food";
    public static GIFTCATEGORY_EXTRA: string = "extras";
    public static GIFTCATEGORY_EVENT: string = "events";

    // SHOP CATEGORY
    public static CATEGORY_APPEARANCE: string = "appearance";
    public static CATEGORY_CLOTHS: string = "cloths";
    public static CATEGORY_EXTRAS: string = "extras";
    public static CATEGORY_EVENT: string = "event";
    public static CATEGORY_BOOSTER: string = "booster";
    public static CATEGORY_THEME: string = "theme";
    public static CATEGORY_STARTER_PACKAGES: string = "starterPackages";

    // SHOP SUB CATEGORY EVENT
    public static SUB_CATEGORY_BOOSTERCHIPS: string = "shopBoosterChipsXP";

    // SHOP SUB CATEGORY EVENT
    public static SUB_CATEGORY_COSTUME: string = "shopCostume";
    public static HAIR_ITEMCATEGORY: string = "hair";
    public static ITEM_CATEGORIES_NONCOSTUME: any[] = ["tshirts", "poloshirts", "shirt", "pullover", "suit", "jacket", "legs", "shoes", "tie", "bags"];

    // SHOP SUB CATEGORY APPEARANCE
    public static SUB_CATEGORY_SKIN: string = "shopSkin";
    public static SUB_CATEGORY_HAIR: string = "shopHair";
    public static SUB_CATEGORY_EYES: string = "shopEyes";
    public static SUB_CATEGORY_NOSE: string = "shopNose";
    public static SUB_CATEGORY_MOUTH: string = "shopMouth";
    public static SUB_CATEGORY_BEARD: string = "shopBeard";

    // SHOP SUB CATEGORY CLOTHS
    public static SUB_CATEGORY_TOP: string = "shopTop";
    public static SUB_CATEGORY_JACKET: string = "shopJacket";
    public static SUB_CATEGORY_BOTTOM: string = "shopBottom";
    public static SUB_CATEGORY_SHOES: string = "shopShoes";

    // SHOP SUB CATEGORY EXTRAS
    public static SUB_CATEGORY_BACKGROUND_SCREEN: string = "shopScreen";
    public static SUB_CATEGORY_BACKGROUND: string = "shopBackground";
    public static SUB_CATEGORY_GIMMICKS: string = "shopGimmicks";
    public static SUB_CATEGORY_ACCESSOIRES: string = "shopAccessoires";
    public static SUB_CATEGORY_JEWELRY: string = "shopJewelry";
    public static SUB_CATEGORY_PET: string = "shopPet";

    // SHOP SUB CATEGORIES OF CATEGORY
    public static SUB_CATEGORIES_APPEARANCE: string[] = [
        "shopSkin",
        "shopHair",
        "shopEyes",
        "shopNose",
        "shopMouth",
        "shopBeard"
    ];

    public static SUB_CATEGORIES_CLOTHS: string[] = [
        "shopTop",
        "shopJacket",
        "shopBottom",
        "shopShoes"
    ];

    public static SUB_CATEGORIES_EXTRAS: string[] = [
        "shopBackground",
        "shopGimmicks",
        "shopAccessoires",
        "shopJewelry",
        "shopPet"
    ];

    public static SUB_CATEGORIES_BOOSTER: string[] = [
        "shopBoosterChipsXP"
    ];

    public static SUB_CATEGORIES_EVENT: string[] = [
        "shopCostume"
    ];

    public static SUB_CATEGORIES_THEME: string[] = [
        "shopScreen"
    ];

    //VIEW CONSTANTS
    public static RANKING_VIEW: number = 0;
    public static ON_TABLE_VIEW: number = 1;

    // TABLE TYPES
    public static STANDARD_TABLE_NORMAL: number = 0;
    public static STANDARD_TABLE_FAST: number = 1;
    public static STANDARD_TABLE_MIN50BB: number = 2;

    // TOURNAMENT TYPES
    public static TOURNAMENT_TYPE_SHOOTOUT: number = 0;
    public static TOURNAMENT_TYPE_FREEZEOUT: number = 1;
    public static TOURNAMENT_TYPE_REBUY: number = 2;

    // SPECIAL EVENTS
    public static HALLOWEEN: string = "halloween";
    public static XMAS: string = "xmas";
    public static FOOTBALL: string = "football";

    // BONUS REGISTER EVENTS
    public static BONUS_20: number = 20;
    public static BONUS_50: number = 50;
    public static BONUS_100: number = 100;

    // XP EVENTS
    public static REGISTER_BONUS_XP: number = 0;
    public static PRIME_TIMEBONUS_XP: number = 1;

    // STARTER PACKAGES
    public static STARTER_PACKAGE_1: string = "Package_1_S_expression";
    public static STARTER_PACKAGE_2: string = "Package_3_L_expression";
    public static STARTER_PACKAGE_3: string = "Package_2_S_performance";
    public static STARTER_PACKAGE_4: string = "Package_4_L_performance";

    constructor() {
    }

    public static setServerBalancingConstants(params: any[]): void {
    }

    public static __initialize_static_members() {
        Poker2Constants.NEW_SHOPITEM_LEFTTIME = 14 * 24 * 60 * 60;
    }
}
Poker2Constants.__initialize_static_members();
